import {Component, Input} from "@angular/core";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'button-heating-systems-overview',
  templateUrl: './button-heating-systems-overview.component.html',
  styleUrls: ['./button-heating-systems-overview.component.scss'],
  imports: [
    MatButton,
    TranslateModule
  ],
  standalone: true
})
export class ButtonHeatingSystemsOverviewComponent {
  @Input() installation: string | undefined;

  openHeatingSystemsOverview() {
    let link = `https://systems-overview.viessmann-climatesolutions.com`;
    if (this.installation) {
      link += `/details/${this.installation}`;
    }
    window.location.href = link;
  }
}
